/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clone } from 'lodash';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import InputWithUnit from 'shared/ui/components/form-components/InputWithUnit.vue';
import { unitConverter } from 'shared/libs/utils/numbers';

const __vue_script__ = {
    name: 'BadgeEditorLayout',

    components: {
        BaseInput,
        BaseSelect,
        InputWithUnit,
    },

    props: {
        event: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            default: () => ({
                mode: 'standalone'
            })
        },
        value: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            presets: [],
            ready: false,
            selectedPreset: undefined,
            selectedUserUnit: undefined,
            units: [],
        };
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(value) {
                this.setSelected(value);
            }
        }
    },

    async created() {
        try {
            const metadata = await this.$services.metadata.getMetadataForType(this.event._id, 'badge_design');
            this.presets = metadata.preset.kind_options.values;
            this.units = metadata.unit.kind_options.values;
            this.setSelected(this.value);
            this.ready = true;
        } catch (error) {
            console.error('[BadgeLayout] Could not load initial data', error);
        }
    },

    methods: {
        /** @param {{ preset: string, userUnit: 'in'|'mm' }} value */
        setSelected({ preset, userUnit }) {
            this.selectedPreset = this.presets.find(({ value }) => value === preset);
            this.selectedUserUnit = this.units.find(({ value }) => value === userUnit);
        },

        convertUnit(value, from, to) {
            const converted = unitConverter(value, from, to);

            if (to === 'in') {
                return Number.parseFloat(converted.toFixed(2));
            }
            return Math.round(converted);
        },

        handleInput(property, value) {
            let nextValue = clone(this.value);
            if (property === 'userUnit') {
                const { value: unit } = value;
                nextValue.userUnit = unit;
                // when preset is other the user unit is the preset unit
                if (nextValue.preset === 'other') {
                    const units = [this.value.userUnit, unit];
                    nextValue.unit = unit;
                    nextValue.width = this.convertUnit(nextValue.width, ...units);
                    nextValue.height = this.convertUnit(nextValue.height, ...units);
                }
            } else if (property === 'preset') {
                // here "value" is the whole preset
                nextValue.width = value.width;
                nextValue.height = value.height;
                nextValue.dpi = value.dpi;
                nextValue.unit = value.unit;
                nextValue.preset = value.value;
                nextValue.format = this.selectedPreset.label;
                nextValue.userUnit = value.unit;
            } else {
                nextValue[property] = value;
            }
            this.$emit('input', nextValue);
        },
        async validate() {
            return this.$refs.form.validate();
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "validation-observer",
        {
          ref: "form",
          staticClass: "badge-editor-layout",
          attrs: { tag: "form" },
        },
        [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "grouped-controls" }, [
              _c(
                "div",
                { staticClass: "form-groups" },
                [
                  _c("validation-provider", {
                    attrs: { slim: true, name: "name", rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            return [
                              _c("base-input", {
                                attrs: {
                                  name: "name",
                                  value: _vm.value.name,
                                  label: _vm.$t(
                                    "onsite_scanning.design.layout_name"
                                  ),
                                  errors: errors,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleInput("name", $event)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1262014840
                    ),
                  }),
                  _vm.value.preset !== "other"
                    ? _c("validation-provider", {
                        attrs: { slim: true, name: "unit", rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("base-select", {
                                    attrs: {
                                      name: "unit",
                                      value: _vm.selectedUserUnit,
                                      "allow-empty": false,
                                      options: _vm.units,
                                      label: _vm.$t(
                                        "onsite_scanning.design.layout_unit"
                                      ),
                                      errors: errors,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.handleInput(
                                          "userUnit",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          558408307
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "grouped-controls" }, [
              _c(
                "div",
                { staticClass: "form-groups" },
                [
                  _c("validation-provider", {
                    attrs: { slim: true, name: "preset", rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            return [
                              _c("base-select", {
                                attrs: {
                                  name: "preset",
                                  "allow-empty": false,
                                  options: _vm.presets,
                                  label: _vm.$t(
                                    "onsite_scanning.design.layout_preset"
                                  ),
                                  errors: errors,
                                  "track-by": "value",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleInput("preset", $event)
                                  },
                                },
                                model: {
                                  value: _vm.selectedPreset,
                                  callback: function ($$v) {
                                    _vm.selectedPreset = $$v
                                  },
                                  expression: "selectedPreset",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1744206501
                    ),
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.value.preset === "other"
            ? _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "grouped-controls" }, [
                  _c(
                    "div",
                    { staticClass: "form-groups" },
                    [
                      _c("validation-provider", {
                        attrs: { slim: true, name: "dpi", rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("base-input", {
                                    attrs: {
                                      type: "number",
                                      min: "1",
                                      name: "dpi",
                                      value: _vm.value.dpi,
                                      label: _vm.$t(
                                        "onsite_scanning.design.layout_dpi"
                                      ),
                                      errors: errors,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.handleInput("dpi", $event)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3766404760
                        ),
                      }),
                      _c("validation-provider", {
                        attrs: { slim: true, name: "unit", rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("base-select", {
                                    attrs: {
                                      name: "unit",
                                      value: _vm.selectedUserUnit,
                                      "allow-empty": false,
                                      options: _vm.units,
                                      label: _vm.$t(
                                        "onsite_scanning.design.layout_unit"
                                      ),
                                      errors: errors,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.handleInput(
                                          "userUnit",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          558408307
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "grouped-controls" }, [
                  _c(
                    "div",
                    { staticClass: "form-groups" },
                    [
                      _c("validation-provider", {
                        attrs: { slim: true, name: "width", rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "input-with-unit",
                                    {
                                      attrs: {
                                        type: "number",
                                        min: "1",
                                        name: "width",
                                        value: _vm.value.width,
                                        label: _vm.$t(
                                          "onsite_scanning.design.layout_width"
                                        ),
                                        errors: errors,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleInput(
                                            "width",
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.selectedUserUnit.value)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3288776107
                        ),
                      }),
                      _c("validation-provider", {
                        attrs: {
                          slim: true,
                          name: "height",
                          rules: "required",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "input-with-unit",
                                    {
                                      attrs: {
                                        type: "number",
                                        min: "1",
                                        name: "height",
                                        value: _vm.value.height,
                                        label: _vm.$t(
                                          "onsite_scanning.design.layout_height"
                                        ),
                                        errors: errors,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleInput(
                                            "height",
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.selectedUserUnit.value)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2618500171
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/editors/badge-editor/BadgeEditorLayout.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__